// primary color by hostname
export const primaryColor = (hostName: any) => {
  if (hostName === 'rantalainen.finadeck.fi') return '#003e79'
  return '#0225a1'
}
